import React from "react";
import {FooterContainer, FooterInner, FooterText, IconWrapper} from "./styles";
import CpuIcon from "../../assets/icons/cpu.svg";
import {SidebarTab} from "../Sidebar";
import IconOpenLink from "../../assets/icons/open-link-white.svg";

interface SidebarCardFooterProps {
  activeTab: SidebarTab;
}
interface FooterContent {
  text: string;
  icon: string;
  isLink: boolean;
}

const SidebarCardFooter: React.FC<SidebarCardFooterProps> = ({activeTab}) => {
  const getFooterContent = (): FooterContent | null => {
    if (activeTab === SidebarTab.Clusters) {
      return {
        text: "Перейти к отраслевой карте технологий",
        icon: CpuIcon,
        isLink: false,
      };
    } else if (activeTab === SidebarTab.CPU) {
      return {
        text: "Перейти к карте субтехнологий",
        icon: CpuIcon,
        isLink: false,
      };
    }
    if (activeTab === SidebarTab.StateInitiative) {
      return {
        text: "ЗАДАТЬ ВОПРОС НА СТРАНИЦЕ ЦРГЦИ",
        icon: IconOpenLink,
        isLink: true,
      };
    }
    return null;
  };

  const footerContent = getFooterContent();

  return (
    <>
      {footerContent &&
        activeTab !== SidebarTab.CPU &&
        activeTab !== SidebarTab.Clusters && (
          <FooterContainer>
            {footerContent.isLink ? (
              <FooterInner
                href={footerContent.isLink ? "https://google.com" : undefined}
                target="_blank"
                rel="noreferrer"
              >
                <FooterText>{footerContent.text}</FooterText>
                <IconWrapper>
                  <img
                    src={footerContent.icon}
                    alt="Footer Icon"
                    width={"100%"}
                    height={"100%"}
                  />
                </IconWrapper>
              </FooterInner>
            ) : (
              <FooterInner>
                <FooterText>{footerContent.text}</FooterText>
                <IconWrapper>
                  <img
                    src={footerContent.icon}
                    alt="Footer Icon"
                    width={"100%"}
                    height={"100%"}
                  />
                </IconWrapper>
              </FooterInner>
            )}
          </FooterContainer>
        )}
    </>
  );
};

export default SidebarCardFooter;
